import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { translateError } from '@/utils/translateError';
import { getConfigurationErrorsForCurrentView } from '@/redux/draft/getters/getConfigurationErrorsForCurrentView';
import { getErrorForSelectedConfiguration } from '@/redux/draft/getters/getErrorForSelectedConfiguration';
import { Error } from '@/components/common/icons/Error';
import './ConfigurationErrorMessage.scss';

export const ConfigurationErrorMessage: FunctionComponent = () => {
  const selectedConfigurationError = useSelector(getErrorForSelectedConfiguration);
  const anyConfigurationError = useSelector(getConfigurationErrorsForCurrentView);

  const anyError = selectedConfigurationError || anyConfigurationError?.[0];
  if (!anyError) {
    return null;
  }

  return (
    <div className="configuration-error-message">
      <Error width="1.5em" height="1.5em" style={{ flexShrink: 0 }} />
      <span className="configuration-error-message__text">{translateError(anyError)}</span>
    </div>
  );
};
